define('views/modules/template/edit/calendar/nutrition/nutrition-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parts views
    'views/parts/menu/menu-save-action',
    // views
    'views/modules/calendar/nutrition/nutrition-edit-content',
    // services
    'services/i18n'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // parts views
    VMenuSaveAction,
    // views
    VNutritionEditContent,
    // services
    i18n
) {

    var VTemplateNutritionEditContent = VNutritionEditContent.extend({

        initialize: function(opt) {
            VTemplateNutritionEditContent.__super__.initialize.call(this, opt);

            var view = _.extend(this.view, {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSaveClick,
                    radio: false,
                    collection: new Backbone.Collection([
                        { title: 'calendar:Add an entry to this log', content: '<strong>+</strong>', itemClass: 'big-action', callback: this.onAddFoodAction },
                        { icon: 'sl-icon-star', title: i18n.t('calendar:add-nutrilog-to-favorite'), callback: this.onAddToFavoriteAction }
                    ]),
                    tooltip: { container: this.regions.root, }
                })
            });

            this.view.menu.addMoreActions(new Backbone.Collection([
                { icon: 'sl-icon-check', caption: i18n.t('calendar:Mark all as consumed'), context: this, callback: this.onMarkAllAsConsumed },
                { icon: 'sl-icon-close', caption: i18n.t('calendar:Mark all as not consumed'), context: this, callback: this.onMarkAllAsNotConsumed },
            ]))
        },

        /////////////
        // actions //
        /////////////

        onSaveClick: function() {
            this.onSubmit();
            this._onSuccess();
        },

        onSubmit: function() {
            if (this.hasCollectionChanged()) {
                this.model.setEntries(this.collection.toJSON());
            }
        },

    });

    return VTemplateNutritionEditContent;
});

